import { useDeviceType } from '~/context/common/DeviceContext';
import { DeviceType } from '~/contracts/common';
import {
  ImageContainer,
  SkyImage,
  StyledSuccessCheck
} from './ImageSection.styles';

enum Device {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet'
}

const deviceMap = {
  isDesktop: Device.Desktop,
  isMobile: Device.Mobile,
  isTablet: Device.Tablet
};

const getDevice = (deviceTypes: Partial<DeviceType>): Device => {
  const truthyDeviceType = Object.entries(deviceTypes).find(([_key, value]) =>
    Boolean(value)
  );
  const device = truthyDeviceType ? deviceMap[truthyDeviceType[0]] : 'mobile';

  return device;
};

type OwnProps = {
  isSubmitted: boolean;
};

const ImageSection = ({ isSubmitted }: OwnProps) => {
  const deviceType = useDeviceType();
  const { isDesktop, isMobile, isTablet } = deviceType;
  const device = getDevice({ isDesktop, isMobile, isTablet });

  return (
    <ImageContainer>
      <SkyImage
        src={`${
          process.env.CVNA_APP_CDN_URL
        }/merch-assets/rbp/modal/sky-${device}-${
          isSubmitted ? 'success' : 'default'
        }.png`}
        alt="sky"
      />
      <img
        className="absolute left-0 top-0 transition-all duration-500 ease-in-out"
        src={`${
          process.env.CVNA_APP_CDN_URL
        }/merch-assets/rbp/modal/jaxson-${device}-${
          isSubmitted ? 'success' : 'default'
        }.png`}
        alt="jaxson-trick"
      />
      <div className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] transform">
        <StyledSuccessCheck className={isSubmitted ? 'scale-1' : 'scale-0'} />
      </div>
    </ImageContainer>
  );
};

export default ImageSection;
